import React from 'react'
import { Card, CardContent, ButtonBase, Stack, Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { selectInvitationState } from "../../sagas/invitations/invitationSlice";
import { ResidentpageState } from '../../ResidentpageState';
import { useHistory } from 'react-router-dom';
import { setAccountActivationDetails } from '../../../sagas/auth/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import { AccountActivationSubjectDto, SearchResident } from "@inosio/payments-sdk";

interface PropsType {
  setPageState: React.Dispatch<React.SetStateAction<ResidentpageState>>,
}

const useStyles = makeStyles({
  text: {
    fontFamily: 'Work Sans',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '21px',
    color: '#14142B',
  },
  card: {
    '&.MuiCard-root': {
      width: '100%',
      backgroundColor: '#ffffff',
      boxShadow: 'rgb(0 0 0 / 10%) 0px 0px 40px',
      borderRadius: '20px',
      marginBottom: '16px',
    }
  },
  cardContainer: {
    maxHeight: 460, 
    overflow: 'auto', 
    padding: '36px 40px 20px', 
    width: '100%',
    marginTop: '0 !important',
  }
});

export default function SelectResident(props: PropsType) {
  const classes = useStyles();

  const { residentResponse } = useSelector(selectInvitationState);

  const getResidentCard = (r: SearchResident, index: number) => (
    <Card classes={{ root: classes.card }} key={index}>
      <ButtonBase 
        sx={{ display: 'block', textAlign: 'initial', width: '100%' }}
        onClick={()=> {selectResident(r)}}
      >
        <CardContent sx={{ padding: '14px' }}>
          <Typography sx={{ lineHeight: '23px', fontWeight: '700' }} className={classes.text} gutterBottom>
            {r.FirstName} {r.MiddleName || ''} {r.LastName}
          </Typography>
          <Typography className={classes.text}>
            {r.Address.Line1}
          </Typography>
          <Typography className={classes.text}>
            {r.Address.City}, {r.Address.State} {r.Address.Zip}
          </Typography>
        </CardContent>
      </ButtonBase>
    </Card>
  )

  const navigation = useHistory();
  const dispatch = useDispatch();

  const selectResident = (resident: SearchResident) => {
    dispatch({
      type: setAccountActivationDetails.type,
      payload: {
        CompanyDbaName: resident.CompanyDbaName,
        FirstName: resident.FirstName,
        MiddleName: resident.MiddleName,
        LastName: resident.LastName,
        Email: resident.Email,
        Uuid: resident.Uuid,        
        EntityType: "Resident",
      } as AccountActivationSubjectDto,
    });

    navigation.push({
      pathname: "/completeregistration",
      state: {
        token: resident.verificationToken,
        residentUuid: resident.Uuid,
      }
    })
  }

  return (
    <Stack direction="column" justifyContent="center" alignItems="center" spacing={2}>
      <Box sx={{ width: "200px" }}>
        <Typography className={classes.text} sx={{ textAlign: 'center' }}>
          Please select your profile
        </Typography>
      </Box>

      {residentResponse?.residents?.length ? (
        <Box className={classes.cardContainer}>
          {residentResponse.residents.map((r: SearchResident, index: number) => getResidentCard(r, index))}
        </Box>
      ):(
        <></>
      )}
    </Stack>
  )
}
